// The `toast` interface: a short message to the user that goes away on its
// own. A plugin asks `getApi('toast')` and calls `show`; the provider
// (shared-toast today) decides where it appears, how it looks and for how
// long, and may add handling of its own, such as logging what was shown.

export const TOAST_API = 'toast';
export const TOAST_VERSION = '1.0.0';

/**
 * `error`, `warning` and `info` show their icon and tint; `none`, or no kind
 * at all, shows the message alone.
 */
export type ToastKind = 'error' | 'warning' | 'info' | 'none';

export interface ToastOptions {
  kind?: ToastKind;
  /** How long the toast stays, in milliseconds; the provider has a default, longer for errors. */
  durationMs?: number;
  /** Stays until dismissed, or closed through the handle (2026-10-14): for a toast that waits for something. */
  sticky?: boolean;
  /** A button in the toast (2026-10-14): "Review" on a new game. The toast closes when it is pressed. */
  action?: { label: string; onClick(): void };
}

/** A toast shown: its message can change while it is up, and it can be closed. */
export interface ToastHandle {
  update(message: string): void;
  close(): void;
}

export interface Toast {
  show(message: string, options?: ToastOptions): ToastHandle;
}
